function filtrer(cat, tab) {
  document.querySelectorAll('.ias-tab').forEach(function(t) { t.classList.remove('active'); });
  tab.classList.add('active');
  document.querySelectorAll('.ias-card').forEach(function(card) {
    if(cat === 'tous') {
      card.classList.remove('hidden');
    } else {
      var cats = card.getAttribute('data-cat') || '';
      if(cats.indexOf(cat) !== -1) { card.classList.remove('hidden'); }
      else { card.classList.add('hidden'); }
    }
  });
}